import React, { PropsWithChildren } from "react";
import { Outlet } from "react-router";

////////////////////////////////////////////////////////////////////////////////

type DevPlanListPagination = {
    page: number;
};

type DevPlanContextType = {
    userId: string | null;
    includeArchived: boolean;
    pagination: DevPlanListPagination;
    setPagination: (data: DevPlanListPagination) => void;
    setIncludeArchived: (archived: boolean) => void;
    setUserId: (userId: string | null) => void;
};

const DevPlanContext = React.createContext<DevPlanContextType>(undefined!);

////////////////////////////////////////////////////////////////////////////////

export const useDevPlanManagementContext = () => React.useContext(DevPlanContext);

////////////////////////////////////////////////////////////////////////////////

const DevPlanManagementWrapper: React.FC<PropsWithChildren> = () => {

    const [pagination, setPagination] = React.useState<DevPlanListPagination>({ page: 1 });
    const [includeArchived, setIncludeArchived] = React.useState<boolean>(false);
    const [userId, setUserId] = React.useState<string | null>(null);

    return (
        <DevPlanContext.Provider
            value={
                {
                    pagination,
                    setPagination: (data: DevPlanListPagination) => setPagination(data),
                    includeArchived,
                    setIncludeArchived: (data: boolean) => setIncludeArchived(data),
                    userId: userId,
                    setUserId: (userId: string | null) => setUserId(userId)
                }
            }
        >
            <Outlet />
        </DevPlanContext.Provider>
    );
};

export default DevPlanManagementWrapper;
